import { BaseComponentPlus } from "react-vextensions";
import { SetCurrentMapTool } from "../MapScene";
export class Tool {
}
export function ToolUI(defaultProps, initialState, initialStash) {
    class ToolUI extends BaseComponentPlus(defaultProps, initialState, initialStash) {
        get MapScene() { return this.props.mapScene; }
        ComponentDidMount() {
            SetCurrentMapTool(this);
        }
        ComponentWillUnmount() {
            SetCurrentMapTool(null);
        }
        // return "true" to mean "the event was captured/absorbed"
        Scene_OnMouseDown(e) { }
        Scene_OnMouseMove(e) { }
        Scene_OnMouseUp(e) { }
        Scene_OnWheel(e) { }
        RenderInScene() { return null; }
        RenderInSceneOverlay() { return null; }
        RenderForObject(obj, extraInfo) { return null; }
        RenderForObject_Overlay(obj, extraInfo) { return React.createElement("div", null); }
    }
    //return ToolUI as any as new(..._)=>BaseComponent<PassedProps & Partial<ConnectProps>, State>;
    return ToolUI;
}
export class ToolRender_ExtraInfo {
    constructor() {
        // these can be overriden within the RenderForObject functions
        this.cancelNormalRender = false;
    }
}
